import React, { Component } from "react";
import { Consumer } from "../libs/AuthContext";
import  Auth  from "@aws-amplify/auth";
import { Header, Button, Form, Grid, Modal, Segment, Divider, Menu } from "semantic-ui-react";
import { translate } from 'react-i18next';
import i18n from "i18next";
import {languages, languagesFR} from "../libs/utility";
import "./VerificationCode.css";

class VerificationCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      confirmation: "",
      newUser: null,
      resent: false
    };
  }

  validateConfirmationForm() {
    return this.state.confirmation.length > 0;
  }

  handleChange = (event, data) => {
    this.setState({
      [data.id]: data.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
    await Auth.resendSignUp(this.state.email);
    this.setState({ resent: true});
  }catch (e) {
    console.log(e);

  }
  this.setState({ isLoading: false });

  }

  handleConfirmationSubmit = async event => {
    event.preventDefault();
    let email = this.state.email.toLowerCase();

    this.setState({ isLoading: true });

    try {
      await Auth.confirmSignUp(email, this.state.confirmation);

    } catch (e) {
      alert(e.message);
      this.setState({ isLoading: false });
    }
  }

  renderConfirmationForm() {
    const { t } = this.props
    return (
      <Form onSubmit={this.handleConfirmationSubmit} autoComplete="nope" className="loginForm">
        <p style={{textAlign: "center", color: "#39474F"}}>
          {t('Please check your email for the code If you do not recieve an email from infoscenarexca in the next 10 minutes please check your spam folder')}
        </p>
        <Form.Input
          id="confirmation"
          label={t("Confirmation Code")}
          type="number"
          defaultValue={this.state.confirmationCode}
          onChange={this.handleChange}
          size="huge"
        />
        <Modal trigger={
          <Button
            fluid
            disabled={!this.validateConfirmationForm()}
            type="submit"
            loading={this.state.isLoading}
          >
          {t('Verify')}
          </Button>}
          basic size='small'>
        <Header content={t('Account Confirmation')} />
        <Modal.Content>
          <p style={{color: "#39474F"}}>
            {t('Your account has been verified Click to login')}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button as="a" href="/login">
           {t('Login')}
          </Button>
        </Modal.Actions>
        </Modal>
      </Form>
    );
  }

  renderForm() {
    const { t } = this.props
    return (
      <Form onSubmit={this.handleSubmit} autoComplete="nope" className="loginForm">
        <Form.Input
          id="email"
          placeholder={t('Email Address')}
          type="string"
          defaultValue={this.state.email}
          onChange={this.handleChange}
          size="large"
        />
        <Button
          fluid
          type="submit"
          loading={this.state.isLoading}
        >
          {t('Resend Verification Code')}
        </Button>
      </Form>
  );
}

render() {
  const { t } = this.props
  return (
    <main className="verificationCode">
      <Segment textAlign='center' vertical className="topMenuSeg">
        <Menu fixed="top" borderless size="small" as="nav" style={{borderBottomColor: "rgba(34, 36, 38, 0.15", backgroundColor: "#39474F"}}>
          <Menu.Item>
            <a href="/"><img style={{width: "170px", height: "auto"}}src={"/logo-horizontal.png"} alt=""/></a>
          </Menu.Item>
          <Menu.Menu position="right" className="headerComp">
              <Menu.Item >
                <a href="https://www.bookchain.ca/" style={{color: "#FFFFFF"}}>{t('Homepage')}</a>
              </Menu.Item>
              <Menu.Item >
                <a href="https://www.bookchain.ca/whatisbookchain" style={{color: "#FFFFFF"}}>{t('What is Bookchain®?')}</a>
              </Menu.Item>
              <Menu.Item>
                <Form.Dropdown
                  fluid
                  selection
                  options={i18n.language === "en" ? languages : languagesFR}
                  value={i18n.language}
                  onChange={(event,data) => i18n.changeLanguage(data.value)}
                  />
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        </Segment>
        <Grid centered className="loginMain">
          <Grid.Column computer={8} mobile={16}>
            <Segment className="segmentLogin">
              <Header as="h2" textAlign={"center"}>{t('Verify Your Account')}</Header>
              <Divider hidden />
              {this.state.resent
                ? this.renderConfirmationForm()
                : this.renderForm()}
            </Segment>
        </Grid.Column>
      </Grid>
      <div className="trim" style={{zIndex: "100", maxHeight: "300px"}}>
        <img alt="" width={400} height={400} align='bottom' src={"/copyrightwhite.png"} style={{marginLeft: -170}}/>
      </div>
</main>
  );
}
}

  export default translate("translations")(props => (
    <Consumer>
      {value => <VerificationCode {...props} context={value} />}
    </Consumer>
  )
)
